import React from 'react';
import styled from 'styled-components';

import { InfoHint } from 'components/common/InfoHint';
import { useFormatMode } from 'state/FormatContext';
import type { ActionOutputField } from 'model/actions';
import { formatTypeLabel } from 'model/actions';
import { formatName } from 'model/nameFormatting';
import { getTypeHint } from 'model/hints';

const StyledSection = styled.section`
  margin-bottom: 1.25rem;
`;

const StyledSectionLabel = styled.h4`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.colors.textMuted};
  margin: 0 0 0.625rem;
`;

const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

const StyledItem = styled.li`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
`;

const StyledName = styled.span`
  font-weight: 500;
`;

const StyledType = styled.span`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 10.5px;
`;

interface OwnProps {
  outputs: ActionOutputField[];
}

const OutputsSection = ({ outputs }: OwnProps) => {
  const nameMode = useFormatMode();

  if (outputs.length === 0) return null;

  return (
    <StyledSection>
      <StyledSectionLabel>Outputs</StyledSectionLabel>
      <StyledList>
        {outputs.map((o) => {
          const typeHint = getTypeHint(o.type);
          return (
            <StyledItem key={o.name}>
              <StyledName>{formatName(o.name, nameMode)}</StyledName>
              <StyledType>({formatTypeLabel(o.type, o.isCollection)})</StyledType>
              {typeHint && <InfoHint text={typeHint} title={o.name} />}
            </StyledItem>
          );
        })}
      </StyledList>
    </StyledSection>
  );
};

export default React.memo(OutputsSection);
